import React from 'react';
import MinimalLayout from "../../layouts/minimal";

export default function NotFound () {

  return (
    <div className={"container-fluid vh-100 d-flex align-items-center"}>
      <div className={"col text-center align-items-center align-content-center"}>
        <h1 className="py-8">Page not found.</h1>
        <p className="text-grey-dark">
          Try to navigate via menu or use search.
        </p>
      </div>
    </div>
  );
}

NotFound.getLayout = function getLayout(page) {
  return (
    <MinimalLayout>
      {page}
    </MinimalLayout>
  )
}

NotFound.getSEO = function getSEO() {
  return {
    title: "404 - Page not found",
  }
}
